import { render } from "./gsrsu02010301.vue?vue&type=template&id=32b049b6&scoped=true"
import script from "./gsrsu02010301.vue?vue&type=script&lang=js"
export * from "./gsrsu02010301.vue?vue&type=script&lang=js"

import "./gsrsu02010301.vue?vue&type=style&index=0&id=32b049b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b049b6"]])

export default __exports__